export const getDynamicScheduleAt = (date: Date, secondaryMeterUnit: number, timeUnit: number | null) => {
    switch (timeUnit) {
        case 1:
            date.setDate(date.getDate() + secondaryMeterUnit);
            break;
        case 2:
            date.setDate(date.getDate() + secondaryMeterUnit * 7);
            break;
        case 3:
            date.setMonth(date.getMonth() + secondaryMeterUnit);
            break;
        case 4:
            date.setFullYear(date.getFullYear() + secondaryMeterUnit);
            break;
        default:
            break;
    }
    return date;
}